export enum ButtonVariantType {
  FILLED = "filled",
  MONO="mono",
  Danger="danger"
}

export enum InputType {
  Text="text",
  Date="date",
  Number="number",
  Time="time",
}

export enum BadgeVariant {
  Primary="primary",
  Danger="danger"
}

export enum AlertVariant {
  Small="small",
  Medium="medium",
  Large="large",
  XLarge="x-large"
}
